import React from 'react';
import { PaymentMethodsTypes, PaymentStatusTypes } from '@/hooks/billing/subscriptions/usePaymentModal/usePaymentModal.types';
import { Button } from 'gatorcomponents';

export default {
  title: 'Pagar factura',
  titleSubscriptions: 'Cambiar forma de pago',
  descriptionSubscriptions: 'Elija el método de pago para renovar sus próximas facturas o ajuste las cuotas:',
  invoiceDetails: {
    invoice: 'Factura',
    dueDate: 'Vencimiento',
    subtotal: 'Subtotal',
    totalValue: 'Valor total + impuestos',
    total: 'Total',
    taxes: 'Impuestos',
    credits: 'Créditos',
    amountPaid: 'Ya se ha pagado',
    showDetailsButtonLabel: 'Ver detalles',
    hideDetailsButtonLabel: 'Ocultar detalles',
    vatTooltip: taxRate => `El IVA (Impuesto sobre el Valor Añadido) se aplica de acuerdo con la legislación fiscal del país. La tasa actual es del ${taxRate}%.`,
  },
  successChangeMethodToast: {
    title: 'Pago actualizado',
    info: 'Sus próximas facturas usarán la nueva forma de pago.',
  },
  invoiceDetailsLabel: 'Detalles de la factura',
  selectPaymentMethod: 'Seleccione la forma de pago',
  installmentLabel: (installment, value) => `${installment}x de ${value}`,
  paymentMethods: {
    [PaymentMethodsTypes.BANK_TRANSFER]: {
      name: 'Transferencia bancaria',
      selectPlaceholder: 'Selecciona la opción de pago',
      icon: 'IconSwitch',
    },
    [PaymentMethodsTypes.GP_BOLETO]: {
      name: '',
      icon: 'IconData',
      description: () => <></>,
      getTicketButton: '',
      modalTitle: '',
      instruction: '',
      changeMethodButtonLabel: '',
      ticketTipLabels: {
        0: '',
        1: '',
        2: '',
      },
      saveTicketButton: '',
      printTicketButton: '',
    },
    [PaymentMethodsTypes.GP_PAYPAL]: {
      name: 'PayPal',
      icon: 'IconPayPal',
      directions: 'Haga clic en el botón de arriba para confirmar y realizar su pago en PayPal.',
      selectAccount: 'Seleccione qué cuenta de PayPal le gustaría utilizar:',
      alert: 'Transacción segura y encriptada.',
    },
    [PaymentMethodsTypes.EFECTIVE_PAYMENT]: {
      name: 'Pago en Efectivo',
      icon: 'IconData',
      selectPlaceholder: 'Selecciona la opción de pago',
      buttonLabel: 'Continuar al pago',
      description: 'Será redirigido para completar su pago en una pantalla segura.',
    },
    [PaymentMethodsTypes.PAYU_BOLETO]: {
      name: 'Pago en Efectivo',
      icon: 'IconData',
      selectPlaceholder: 'Selecciona la opción de pago',
      buttonLabel: 'Continuar al pago',
      description: 'Será redirigido para completar su pago en una pantalla segura.',
    },
    [PaymentMethodsTypes.BRASPAG_CREDIT]: {
      name: '',
      icon: '',
      replaceCardLabel: '',
      useOnNextRenovationLabel: '',
      saveCcButtonLabel: '',
      bottomMessage: '',
      selectInstallmentsPlaceholder: '',
    },
    [PaymentMethodsTypes.DLOCAL]: {
      name: 'Nueva Tarjeta de crédito',
      icon: 'IconCard',
      replaceCardLabel: 'Reemplazará la tarjeta anterior en todas las suscripciones vinculadas a ella.',
      useOnNextRenovationLabel: 'Utilice este método de pago para las próximas renovaciones de este(s) producto(s).',
      saveCcButtonLabel: 'Pagar factura y Guardar Tarjeta',
      changeMethodButtonLabel: 'Cambiar y Guardar Tarjeta',
      bottomMessage: 'Transacción segura y encriptada.',
      selectInstallmentsPlaceholder: 'Seleccione el número de cuotas',
    },
    [PaymentMethodsTypes.CURRENT_CREDIT_CARD]: {
      name: 'Tarjeta Registrada',
      selectInstallmentsPlaceholder: 'Seleccione el número de cuotas',
      useOnNextRenovationLabel: 'Utilice este método de pago para las próximas renovaciones de este(s) producto(s).',
      dueLabel: date => `Vence en ${date}`,
      payInvoiceButtonLabel: 'Pagar factura',
      changeMethodButtonLabel: 'Cambiar forma de pago',
      bottomMessage: 'Transacción segura y encriptada.',
    },
    [PaymentMethodsTypes.QR_PAYMENT]: {
      name: 'Pago en Qr',
      icon: 'IconQrCode',
    },
    [PaymentMethodsTypes.WALLET]: {
      name: 'Billetera Electrónica',
    },
    [PaymentMethodsTypes.PIX]: {
      name: 'Pix',
      icon: 'IconPix',
      label: 'Generar código Pix',
      labelChangePaymentMethod: 'Cambiar forma de pago',
      description: "Haga clic en el botón 'Generar código Pix' para confirmar y realizar su pago en la próxima pantalla.",
      descriptionChangePaymentMethod: "Haga clic en el botón 'Cambiar forma de pago' para confirmar y realizar su pago en la próxima pantalla.",
      secureTransition: 'Transacción rápida y segura con Pix.',
    },
    modo: {
      icon: 'IconModo',
    },
    yape: {
      icon: 'IconYape',
    },
    defaultContinue: 'Continuar al pago',
    defaultContinueChangeMethod: 'Cambiar forma de pago',
    defaultDescription: 'Será redirigido para completar su pago en una pantalla segura.',
    multiplePaymentMethodsDescription: 'Será redirigido para completar su pago en una pantalla segura.',
  },
  paymentStatus: {
    [PaymentStatusTypes.SUCCESS_GENERIC]: {
      title: 'Pago completado',
      description: '¡Felicidades! Su pago se ha realizado con éxito. En breve recibirá un correo electrónico de confirmación.',
      buttonLabel: 'Volver a mis facturas',
    },
    [PaymentStatusTypes.FAILURE_CREDIT_CARD]: {
      title: 'Ups! Algo salió mal con su pago',
      description: 'Vuelva a intentarlo en algunos minutos o utilice otra Tarjeta de Crédito. ',
      buttonLabel: 'Intentarlo nuevamente',
      secondButtonLabel: 'Usar otra tarjeta',
    },
    [PaymentStatusTypes.PIX_TIME_EXPIRED]: {
      title: 'Tempo para pagamento esgotado',
      description: 'Altere o método de pagamento ou atualize o QR Code para concluir. Se já realizou o pagamento, você receberá um e-mail de confirmação em breve.',
      buttonLabel: 'Alterar forma de pagamento',
      secondButtonLabel: 'Atualizar QR Code',
    },
    [PaymentStatusTypes.FOLLOW_NEW_TAB_INSTRUCTIONS]: {
      title: 'Siga las instrucciones de la plataforma de pago',
      description: 'Se ha abierto una nueva página para que realice su pago. Siga las instrucciones y acompañe el estado de su pago en su lista de facturas.',
      buttonLabel: 'Cerrar',
      pageNotLoaded: ({ handleClick }) => (
        <>
          {'Si la página no se abre automáticamente, '}
          <Button
            variant="text"
            onClick={handleClick}
            label="haga clic aquí"
          />
        </>
      ),
    },
    [PaymentStatusTypes.PIX_ONGOING]: {
      modalTitle: 'Pagar con Pix',
      contentTitle: 'Copie el código abajo o escanee el QR Code para efectuar el pago.',
      copyTimerText: 'Tiempo restante para el pago:',
      list: [
        'En la App de su banco, seleccione la opción que desea: Pagar QR Code o Pix Copia y Pega;',
        'Después del pago, espere la confirmación en la pantalla;',
        '¡Listo, el pago se ha realizado con éxito!',
      ],
    },
    [PaymentStatusTypes.GENERIC_FAILURE]: {
      title: 'Algo salió mal con su solicitud',
      description: 'Inténtelo de nuevo o utilice otro método de pago.',
      tryAgain: 'Intentar de nuevo',
      anotherMethod: 'Usar otro método de pago',
    },
  },
};
